import { useFormik } from "formik";
import { useTranslation } from "react-i18next";
import Text from "../../../molecules/content/Text";
import PhoneInputField from "../../../molecules/formControls/inputField/PhoneInputField";
import DefaultButton from "../../../atoms/buttons/DefaultButton";
import { SmsLoginValidation } from "./validations";

const SmsLoginForm = ({ countryCode, onSubmit }) => {
  const { t } = useTranslation();

  const initialValues = {
    phone_number: "",
  };

  const formik = useFormik({
    initialValues,
    validationSchema: SmsLoginValidation(t, countryCode),
    onSubmit,
  });

  return (
    <form
      onSubmit={formik.handleSubmit}
      autoComplete="off"
      className="flex flex-col gap-8"
    >
      <div className="flex flex-col gap-4">
        <Text variant="h2" className="flex justify-center text-vestelColor">
          {t("smsLogin.title")}
        </Text>
        <PhoneInputField
          id="phone_number"
          name="phone_number"
          required={true}
          onChange={formik.handleChange}
          countryCode={countryCode}
          onBlur={formik.handleBlur}
          value={formik.values.phone_number}
          formikTouched={formik.touched.phone_number}
          error={formik.errors.phone_number}
        />
      </div>
      <Text variant="small" className="text-center">
        {t("smsLogin.description")}
      </Text>
      <DefaultButton
        type="submit"
        label={t("smsLogin.submit")}
        disabled={!(formik.isValid && formik.dirty) || formik.isSubmitting}
      />
    </form>
  );
};

export default SmsLoginForm;
